<template lang="html">
  <div>
    <mobile-app-links />
    <features-overview />
  </div>
</template>

<script>
import MobileAppLinks from '@/components/blocks/MobileAppLinks';
import FeaturesOverview from '@/components/blocks/FeaturesOverview';
export default {
  name: 'cw-mobile-app',
  components: {
    FeaturesOverview,
    MobileAppLinks,
  },
};
</script>

<style lang="stylus" scoped>
.header {
  min-height: 25vh
  padding-top: 5rem
}
</style>
